import { render, staticRenderFns } from "./RBC.vue?vue&type=template&id=4774ef0c&scoped=true"
import script from "./RBC.vue?vue&type=script&lang=js"
export * from "./RBC.vue?vue&type=script&lang=js"
import style0 from "./RBC.vue?vue&type=style&index=0&id=4774ef0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4774ef0c",
  null
  
)

export default component.exports